(function () {
  'use strict';

  /* =========================================================
     1. SMOOTH SCROLL (LENIS), SAFE FALLBACK
  ========================================================= */

  function detectFlakyBrowser() {
    const ua = navigator.userAgent || '';
    const knownInApp = /Instagram|FBAN|FBAV|FB_IAB|TikTok|Line\//i.test(ua);
    const unmarkedWebview =
      !window.chrome && /iPhone|Android/i.test(ua) && !('standalone' in navigator);
    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    return knownInApp || unmarkedWebview || isTouch;
  }

  const hasLenis = typeof window.Lenis !== 'undefined';
  const hasGsap = typeof window.gsap !== 'undefined';
  const smoothOff = detectFlakyBrowser() || !hasLenis;

  const lenis = smoothOff
    ? { on() {}, stop() {}, start() {}, raf() {}, destroy() {} }
    : new window.Lenis({
        smoothWheel: true,
        smoothTouch: false,
        normalizeWheel: true,
        ignore: (el) => el && el.classList && el.classList.contains('scroll-section')
      });

  // Exposed so the story section (and other sections) can stop/start scroll
  window.bwtLenis = lenis;

  if (!smoothOff && hasGsap) {
    if (window.ScrollTrigger) lenis.on('scroll', () => window.ScrollTrigger.update());
    window.gsap.ticker.add((time) => lenis.raf(time * 1000));
    window.gsap.ticker.lagSmoothing(0);
  } else if (!smoothOff && !hasGsap) {
    // Lenis without GSAP: drive it with rAF
    const loop = (t) => { lenis.raf(t); requestAnimationFrame(loop); };
    requestAnimationFrame(loop);
  }

  /* =========================================================
     2. HEADER MENUS (desktop .bh-menu / mobile .bh-mmenu)
  ========================================================= */

  const MENU_SELECTOR = '.bh-menu, .bh-mmenu';
  const MENU_CLASSES = ['bh-menu', 'bh-mmenu'];

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    if (lock) lenis.stop();
    else lenis.start();
  }

  function updateScrollLock() {
    const open = Array.from(document.querySelectorAll(MENU_SELECTOR))
      .some((m) => m.classList.contains('active'));
    lockScroll(open);
  }

  function closeMenu(menu) {
    if (!menu) return;
    menu.classList.remove('active');
    const cls = Array.from(menu.classList).find((c) => MENU_CLASSES.includes(c));
    if (cls) {
      document
        .querySelectorAll(`.bh-burger[data-target="${cls}"]`)
        .forEach((b) => b.classList.remove('active'));
    }
    updateScrollLock();
  }

  function toggleMenu(btn) {
    const cls = btn.getAttribute('data-target');
    if (!MENU_CLASSES.includes(cls)) return;

    const root = document.querySelector('.bh') || document;
    const menu = root.querySelector(`.${cls}`);
    if (!menu) return;

    const opening = !menu.classList.contains('active');

    document.querySelectorAll(MENU_SELECTOR).forEach((m) => {
      if (m !== menu) closeMenu(m);
    });

    menu.classList.toggle('active', opening);
    document
      .querySelectorAll(`.bh-burger[data-target="${cls}"]`)
      .forEach((b) => b.classList.toggle('active', opening));

    if (opening) {
      const bar = document.querySelector('.bh-main');
      if (bar) bar.classList.remove('to-transform');
      // close notifications when a menu opens
      document.querySelectorAll('.bh-notice.active').forEach((n) => n.classList.remove('active'));
    }

    updateScrollLock();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.bh-burger[data-target]');
    if (btn) {
      e.preventDefault();
      toggleMenu(btn);
      return;
    }
    // backdrop click
    const menu = e.target.closest(MENU_SELECTOR);
    if (menu && e.target === menu) closeMenu(menu);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(`${MENU_SELECTOR}.active`).forEach(closeMenu);
    document.querySelectorAll('.bh-notice.active').forEach((n) => n.classList.remove('active'));
  });

  /* =========================================================
     3. MOBILE ACCORDION
  ========================================================= */

  window.bhAccordion = function (trigger) {
    if (!trigger) return;
    const panel = trigger.closest('.bh-acc');
    if (!panel) return;

    const body = panel.querySelector('.bh-acc__body');
    const arrow = trigger.querySelector('.bh-acc__icon');
    const opening = !panel.classList.contains('active');

    const scope = trigger.closest('.bh-mmenu') || panel.parentElement;
    scope.querySelectorAll('.bh-acc.active').forEach((item) => {
      if (item === panel) return;
      item.classList.remove('active');
      const b = item.querySelector('.bh-acc__body');
      const a = item.querySelector('.bh-acc__icon');
      if (b) b.style.maxHeight = null;
      if (a) a.classList.remove('active');
    });

    panel.classList.toggle('active', opening);
    if (arrow) arrow.classList.toggle('active', opening);
    if (body) body.style.maxHeight = opening ? body.scrollHeight + 'px' : null;
  };

  window.addEventListener('resize', () => {
    document.querySelectorAll('.bh-acc.active .bh-acc__body').forEach((b) => {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  });

  /* =========================================================
     4. NOTIFICATIONS (bell + mobile dock offer icon)
  ========================================================= */

  function setNotice(notice, state) {
    if (!notice) return;
    notice.classList.toggle('active', state);
    const wrapper = notice.closest('.bh-notify');
    const bell = wrapper && wrapper.querySelector('.bh-bell');
    if (bell) bell.classList.toggle('active', state);
    const offerIcon = document.querySelector('.bh-dock__icon--offer');
    if (offerIcon) offerIcon.classList.toggle('active', state);
  }

  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.bh-notice__close');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      setNotice(closeBtn.closest('.bh-notice'), false);
      return;
    }

    const trigger = e.target.closest('.bh-bell, .bh-dock__offer-link');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      const wrapper = trigger.closest('.bh-notify');
      const notice = (wrapper && wrapper.querySelector('.bh-notice')) ||
        document.querySelector('.bh-notice');
      if (!notice) return;

      const wasActive = notice.classList.contains('active');
      document.querySelectorAll('.bh-notice.active').forEach((n) => {
        if (n !== notice) setNotice(n, false);
      });
      setNotice(notice, !wasActive);
      return;
    }

    if (!e.target.closest('.bh-notice')) {
      document.querySelectorAll('.bh-notice.active').forEach((n) => setNotice(n, false));
    }
  });

  /* =========================================================
     5. MOBILE DOCK SCROLL BEHAVIOUR
     (Story ring is handled by the bwt-story-section script)
  ========================================================= */

  function initDock() {
    const dock = document.querySelector('.bh-dock');
    if (!dock || dock.dataset.bwtDockInit) return;
    dock.dataset.bwtDockInit = 'true';

    const THRESHOLD = 8;
    let lastY = window.scrollY;
    let ticking = false;

    function setCollapsed(state) {
      dock.classList.toggle('hide', state);
      document.body.classList.toggle('bh-dock-hide', state);
    }

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = Math.max(window.scrollY, 0);
        const diff = y - lastY;
        if (y <= 0 || diff < -THRESHOLD) setCollapsed(false);
        else if (diff > THRESHOLD) setCollapsed(true);
        if (y <= 0 || Math.abs(diff) > THRESHOLD) lastY = y;
        ticking = false;
      });
    }, { passive: true });

    document.addEventListener('click', (e) => {
      if (!document.body.classList.contains('bh-dock-hide')) return;
      const t = e.target;
      if (!(t instanceof Element)) return;
      const onDock = t.closest('.bh-dock');
      const onBubble = t.closest('#chatbase-bubble-button');
      if (onDock || onBubble) {
        if (onBubble) { e.preventDefault(); e.stopPropagation(); }
        setCollapsed(false);
        lastY = window.scrollY;
      }
    }, true);
  }

  /* =========================================================
     6. SWIPER, PDP TABS, COLLECTION GRID
  ========================================================= */

  function bootCarousels(scope) {
    if (typeof window.Swiper === 'undefined') return;
    (scope || document)
      .querySelectorAll('.swiper-container:not(.swiper-initialized)')
      .forEach((el) => {
        if (el.closest('.cust-recom')) return;
        new window.Swiper(el, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev')
          },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
      });
  }

  function initPage() {
    bootCarousels();

    document.querySelectorAll('product-recommendations').forEach((block) => {
      if (block.dataset.bwtObserverInit) return;
      block.dataset.bwtObserverInit = 'true';
      new MutationObserver(() => bootCarousels(block))
        .observe(block, { childList: true, subtree: true });
    });

    // PDP accordion tabs
    document.addEventListener('click', (e) => {
      const root = e.target.closest('.pdp-accordion-main');
      if (!root) return;
      const tab = e.target.closest('.accordion-title li');
      if (!tab || !root.contains(tab)) return;
      const key = tab.dataset.tab;
      root.querySelectorAll('.accordion-title li').forEach((t) => t.classList.toggle('active', t === tab));
      root.querySelectorAll('.accordion-content').forEach((p) => p.classList.toggle('active', p.dataset.content === key));
    });

    // Collection grid switcher
    const collection = document.querySelector('.cust-collection-page2');
    if (collection && !collection.dataset.bwtGridInit) {
      collection.dataset.bwtGridInit = 'true';
      const COL_CLASSES = [1, 2, 3, 4, 5, 6].map((n) => `cols-${n}`);
      const choices = collection.querySelectorAll('#bwt-content-right-view-varient li[data-columns]');

      const applyColumns = (cols) => {
        if (!COL_CLASSES.includes(`cols-${cols}`)) return;
        collection.classList.remove(...COL_CLASSES);
        collection.classList.add(`cols-${cols}`);
        choices.forEach((li) => li.classList.toggle('active', parseInt(li.dataset.columns, 10) === cols));
      };

      applyColumns(4);
      choices.forEach((li) => li.addEventListener('click', () => applyColumns(parseInt(li.dataset.columns, 10))));
    }

    initDock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage, { once: true });
  } else {
    initPage();
  }

  /* =========================================================
     7. CART DRAWER: STOCK-AWARE PLUS BUTTON
  ========================================================= */

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const plusBtn = target.closest('.quantity__button[name="plus"]');
    if (!plusBtn) return;

    const qtyWrap = plusBtn.closest('quantity-input');
    const input = qtyWrap && qtyWrap.querySelector('.quantity__input');
    if (!input) return;

    const tracked = input.dataset.inventoryManagement;
    const policy = input.dataset.inventoryPolicy;
    const stock = parseInt(input.dataset.inventoryQuantity, 10);
    const current = parseInt(input.value, 10) || 0;

    if (tracked !== 'shopify' || policy !== 'deny') return;
    if (Number.isNaN(stock) || current < stock) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const item = qtyWrap.closest('.cart-item');
    const errorBox = item && item.querySelector('.cart-item__error');
    const errorText = errorBox && errorBox.querySelector('.cart-item__error-text');
    if (!errorBox || !errorText) return;

    errorText.textContent = stock <= 0 ? 'This item is out of stock.' : `Only ${stock} left in stock.`;
    errorBox.style.display = 'flex';
    clearTimeout(errorBox._hideTimeout);
    errorBox._hideTimeout = setTimeout(() => { errorBox.style.display = 'none'; }, 3000);
  }, true);

  /* =========================================================
     8. PINCH-ZOOM GUARD (Instagram / Facebook in-app browsers)
  ========================================================= */

  (function pinchGuard() {
    const ua = navigator.userAgent || '';
    if (!/Instagram|FBAN|FBAV|FB_IAB/i.test(ua)) return;

    const root = document.documentElement;
    const opts = { passive: true, capture: true };
    let pinching = false;

    root.classList.add('meta-browser');

    function freeze() {
      if (pinching) return;
      pinching = true;
      root.classList.add('is-pinching');
      lenis.stop();
      if (hasGsap) window.gsap.ticker.sleep();
    }

    function unfreeze() {
      if (!pinching) return;
      pinching = false;
      root.classList.remove('is-pinching');
      const menuOpen = document.querySelector('.bh-menu.active, .bh-mmenu.active');
      const storyOpen = document.querySelector('.bwt-sv.active');
      if (!menuOpen && !storyOpen) lenis.start();
      if (hasGsap) window.gsap.ticker.wake();
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }

    const onMulti = (e) => { if (e.touches.length > 1) freeze(); };

    document.addEventListener('touchstart', onMulti, opts);
    document.addEventListener('touchmove', onMulti, opts);
    document.addEventListener('touchend', (e) => { if (e.touches.length < 2) unfreeze(); }, opts);
    document.addEventListener('touchcancel', unfreeze, opts);
  })();
})();